import React from 'react';

import BannerProTextBlock from 'src/molecules/banner/text.block.mightyPro';
import { BannerBackground, BannerImage, BannerProContainer, BannerProText } from 'organisms/banners/Banner.pro.styles';
import { BannerLandingProps } from 'organisms/banners/Banner.landing';
import PhoneVideoPro from 'src/elements/video/phone.video.pro';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Image from 'src/elements/image/image';

interface BannerProProps extends Omit<BannerLandingProps, 'videoUrl'> {
  image?: IGatsbyImageData;
  videoUrl?: string;
  titleColor?: string;
  isVideo?: boolean;
  removeConfetti?: boolean;
}

const BannerPro = (props: BannerProProps): JSX.Element => {
  return (
    <BannerBackground removeConfetti={props.removeConfetti}>
      <BannerProContainer textPosition={props.textPosition}>
        <BannerProText>
          <BannerProTextBlock
            title={props.title}
            removeRating
            description={props.description}
            actionLink={props.actionLink}
            actionButton={props.actionButton}
            titleColor={props.titleColor}
          />
        </BannerProText>
        {
          props.isVideo ? (
            <PhoneVideoPro videoUrl={props.videoUrl} />
          ) : (
            <BannerImage>
              <Image childImageSharp={props.image} alt="Pro modern creator" />
            </BannerImage>
          )
        }
      </BannerProContainer>
    </BannerBackground>
  );
};

export default BannerPro;
